import { fetchGame } from '../game';
import AlgoliaFactory from '../algolia';
import { fetchJackpots } from '../jackpots';
import { fetchLiveTables } from '../liveTable';
import { fetchPage } from '../page';
import { startPromotionsFlow } from '../promotions';
import { fetchRecentlyPlayed } from '../recentlyPlayed';
import { getCanonicalUrl } from '../seo';

export default {
  fetchGame,
  AlgoliaFactory,
  fetchJackpots,
  fetchLiveTables,
  fetchPage,
  startPromotionsFlow,
  fetchRecentlyPlayed,
  getCanonicalUrl,
};
